import { render, staticRenderFns } from "./generic-scroll-view.vue?vue&type=template&id=e0f0016c&scoped=true&"
import script from "./generic-scroll-view.vue?vue&type=script&lang=tsx&"
export * from "./generic-scroll-view.vue?vue&type=script&lang=tsx&"
import style0 from "./generic-scroll-view.vue?vue&type=style&index=0&id=e0f0016c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f0016c",
  null
  
)

export default component.exports